var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticClass: "main-container full-height"
  }, [(_vm.designerConfig.logoHeader !== false) ? _c('el-header', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "float-right external-link"
  }, [(_vm.showLink('languageMenu')) ? _c('el-dropdown', {
    attrs: {
      "hide-timeout": 2000
    },
    on: {
      "command": _vm.handleLanguageChanged
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v(_vm._s(_vm.curLangName)), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "zh-CN"
    }
  }, [_vm._v(_vm._s(_vm.i18nt('application.zh-CN')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "en-US"
    }
  }, [_vm._v(_vm._s(_vm.i18nt('application.en-US')))])], 1)], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('el-container', {
    staticClass: "main-content"
  }, [_c('el-aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leftAsideVisible),
      expression: "leftAsideVisible"
    }],
    staticClass: "side-panel"
  }, [_c('widget-panel', {
    attrs: {
      "designer": _vm.designer
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left-aside-toggle-bar",
    class: {
      'aside-hidden': !_vm.leftAsideVisible
    },
    on: {
      "click": _vm.toggleLeftAside
    }
  }, [(_vm.leftAsideVisible) ? _c('i', {
    staticClass: "el-icon-caret-left"
  }) : _c('i', {
    staticClass: "el-icon-caret-right"
  })]), _vm._v(" "), _c('el-container', {
    staticClass: "center-layout-container"
  }, [_c('el-header', {
    staticClass: "toolbar-header"
  }, [_c('toolbar-panel', {
    ref: "toolbarRef",
    attrs: {
      "designer": _vm.designer,
      "global-dsv": _vm.globalDsv
    },
    scopedSlots: _vm._u([_vm._l((_vm.$slots), function(idx, slotName) {
      return {
        key: slotName,
        fn: function() {
          return [_vm._t(slotName)]
        },
        proxy: true
      }
    })], null, true)
  })], 1), _vm._v(" "), _c('el-main', {
    staticClass: "form-widget-main"
  }, [_c('el-scrollbar', {
    staticClass: "container-scroll-bar"
  }, [_c('v-form-widget', {
    ref: "formRef",
    attrs: {
      "designer": _vm.designer,
      "form-config": _vm.designer.formConfig,
      "global-dsv": _vm.globalDsv
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right-aside-toggle-bar",
    class: {
      'aside-hidden': !_vm.rightAsideVisible
    },
    on: {
      "click": _vm.toggleRightAside
    }
  }, [(_vm.rightAsideVisible) ? _c('i', {
    staticClass: "el-icon-caret-right"
  }) : _c('i', {
    staticClass: "el-icon-caret-left"
  })]), _vm._v(" "), _c('el-aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightAsideVisible),
      expression: "rightAsideVisible"
    }],
    staticClass: "setting-panel"
  }, [_c('setting-panel', {
    attrs: {
      "designer": _vm.designer,
      "selected-widget": _vm.designer.selectedWidget,
      "form-config": _vm.designer.formConfig,
      "global-dsv": _vm.globalDsv
    }
  })], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c96e9a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/index.vue
// module id = null
// module chunks = 